import React from "react";
import {ThemedIcon} from "@me8eon/icons";
import TypingEffect from "../../ai-assist-refactored/utils/typing-effect/TypingEffect";
import {MessageWithActionAndData} from "@me8eon/sessions_messages";

export const BaseAssistantMessage: React.FC<MessageWithActionAndData> = ({content}) => {
    return (
        <div className="bot-header">
            <div className="eon-logo">
                <ThemedIcon name={"AiIcon"}/>
            </div>
            <div className="bot-reply-container">
                <TypingEffect className="bot-text" text={content} speed={1}/>
            </div>
        </div>
    )
}